import { createContext as e, useContext as r } from "react";
import { NavigatorStepKey as o } from "../../types/index.js";
const t = e({
  currentStep: 0,
  currentStepKey: o.FormatData,
  setCurrentStep: () => {
  },
  setCurrentStepByKey: () => {
  },
  steps: []
}), p = t.Provider, s = () => r(t);
export {
  t as NavigatorContext,
  p as NavigatorProvider,
  s as useNavigator
};
//# sourceMappingURL=NavigatorContext.js.map
